import request from '../utils/request'

export default {
	async list(data) { // 获取设备列表
		return await request('/v1/device/list', data, 'POST')
	},
	async export (data) { // 获取导出
		return await request('/v1/device/export', data, 'POST')
	},
	async info(data) { // 获取设备详情
		return await request('/v1/device/info', data, 'POST')
	},
	async config(data) { // 获取设备配置信息
		return await request('/v1/device/config', data, 'POST')
	},
	async upload(data) { // 添加设备信息
		return await request('/v1/device/upload', data, 'POST')
	},
	async batchUpload(data) { // 批量添加设备信息
		return await request('/v1/device/batch_upload', data, 'POST')
	},
	async allot(data) { // 分配手环
		return await request('/v1/device/allot', data, 'POST')
	},
	async map(data) { // 获取设备地图列表
		return await request('/v1/device/map', data, 'POST')
	},
	async group(data) { // 获取群控设备列表
		return await request('/v1/device/group', data, 'POST')
	},
	async setting(data) { // 获取设备参数
		return await request('/v1/device/setting', data, 'POST')
	},
	async saveSetting(data) { // 保存设备参数
		return await request('/v1/device/save_setting', data, 'POST')
	},
	async batchSaveSetting(data) { // 批量保存设备参数
		return await request('/v1/device/batch_save_setting', data, 'POST')
	},
	async deviceLocalInfo(data) { // 查询设备上报硬件信息(infoNotify)
		return await request('/v1/device/local_info', data, 'POST')
	},
	async batchConfig(data) { // 获取批量设备参数模板
		return await request('/v1/device/batch_config', data, 'POST')
	},
	async uploadFile(data) {
		return await request('/common/upload', data, 'POST', 'multipart/form-data')
	},
	async batchRemove(data) { // 批量删除设备
		return await request('/v1/device/remove', data, 'POST')
	},
	async notice(data) { // 设备通知
		return await request('/v1/device/notice', data, 'POST')
	},
	async noticeList(data) { // 设备通知列表
		return await request('/v1/device/noticeList', data, 'POST')
	},
	async readList(data) { // 通知阅读记录
		return await request('/v1/device/readList', data, 'POST')
	},
	async checkin(data) { // 签到下发
		return await request('/v1/device/checkin', data, 'POST')
	},
	async checkinList(data) { // 签到列表
		return await request('/v1/device/checkinList', data, 'POST')
	},
	async stopCheckin(data) { // 停止签到
		return await request('/v1/device/stopCheckin', data, 'POST')
	},
	async detail(data) { // 设备详情
		return await request('/v1/device/detail', data, 'POST')
	},
	async uwbLists(data) { // uwbLists设备列表
		return await request('/v1/device/uwbLists', data, 'POST')
	},
	async clearData(data) { // 清除设备健康数据
		return await request('/v1/device/clearData', data, 'POST')
	},
	async mqttSend(data) { // MQTT发送
		return await request('/v1/mqtt/send', data, 'POST')
	}
}
